/**
 * Consent Entry Point
 *
 * Mounts the cookie consent modal.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConsentModal } from '@/components/Consent';

const container = document.getElementById('evcs-consent-root');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ConsentModal />
    </StrictMode>
  );
}
